import { render, staticRenderFns } from "./orderRefundDetail.vue?vue&type=template&id=5a4c030c&"
import script from "./orderRefundDetail.vue?vue&type=script&lang=js&"
export * from "./orderRefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports